import { html, TemplateResult } from 'lit-html';
import { TableTxFilterHeaderModel } from '../../../models/table_tx_filter_header_model';
import TableTooltipAction from '../../../actions/table_tooltip_action';

const renderHeaderList = (model: TableTxFilterHeaderModel): TemplateResult[] => {
  return model.headers.map((value) => {
    return html`
      <li class="m-checkboxListItem">
        <div class="a-checkbox js-lazy-img">
          <label class="a-checkbox_label">
            <input
              type="checkbox" class="checkbox_filter"
              ?checked=${value.shouldShown}
              @change="${(event: any) => (value.shouldShown = event.target.checked)}"
            />
            <span class="a-checkbox_icon">
              <span class="a-checkbox_text">${value.specHeaderName}</span>
            </span>
          </label>
        </div>
      </li>
    `;
  });
};
export const TableTxFilterHeaderContent = (model: TableTxFilterHeaderModel) => {
  return html`
    <div class="a-heading -typep u-mb-12">
      <p class="a-heading_text">表示項目設定</p>
    </div>
    <div class="o-colBox -margin12 u-mb-12">
      <a
        href="javascript:;"
        class="a-textlink js-checkboxctrl_all"
        @click=${() => TableTooltipAction.selectAllTableTxHeader(model)}
      >
        すべて選択
      </a>
      <a
        href="javascript:;"
        class="a-textlink js-checkboxctrl_clear"
        @click=${() => TableTooltipAction.clearAllTableTxHeader(model)}
      >
        クリア
      </a>
    </div>
    <hr class="a-line u-mb-16" />
    <div class="a-box -noSpacing -transparent -scrollable u-mb-16" style="height:152px">
      <ul class="m-checkboxList -vertical">
        ${renderHeaderList(model)}
      </ul>
    </div>
    <hr class="a-line u-mb-16" />
    <div class="o-grid -cols2 -vmargin24 -hmargin8" data-col="2">
      <ul class="o-grid_inner">
        <li class="o-grid_cell">
          <a href="javascript:;" class="m-btn -base -small -noPadding js-tooltipContent_close"
          @click=${() => TableTooltipAction.closeModel()}
          >
            <span class="m-btn_inner"><span class="m-btn_text">キャンセル</span></span>
          </a>
        </li>
        <li class="o-grid_cell">
          <a
            href="javascript:;"
            class="m-btn -tertiary -small -noPadding js-tooltipContent_close"
            @click=${() => TableTooltipAction.changeTableTxHeader(model)}
          >
            <span class="m-btn_inner"><span class="m-btn_text">適用</span></span>
          </a>
        </li>
      </ul>
    </div>
  `;
};
